import type { EditorView } from 'prosemirror-view';

import type { ColorSchema } from './color-mark';
import type { ColorMenuController } from './color-plugin.types';
import type { EditorButton, EditorMode } from '../../editor/types';
import { MarkService } from '../../helpers/mark-base';

export class ColorService<S extends ColorSchema> extends MarkService<S> {}

export class ColorPlugin {
  public api: {
    colorService: ColorService<ColorSchema>;
  };

  public buttons = {
    toggleColor: <EditorButton>{
      icon: 'format-color-text',
      tooltipText: 'wysiwyg.fontcolor',
      isActive: (state, ...args) =>
        this.menuController.isOpen() || this.api.colorService.isActive(state),
      run: (state, dispatch, origin) => {
        const colorChanged = (value: string | null) => {
          if (value) {
            this.api.colorService.add(this.editorView.state, dispatch, { hex: value });
          } else {
            this.api.colorService.remove(this.editorView.state, dispatch);
          }
        };
        const current = this.api.colorService.getAttrsIfActive(state);
        const { closed$ } = this.menuController.open(origin.getBoundingClientRect(), {
          parent: origin,
          onChange: colorChanged,
          initialValue: current ? current.hex : null,
        });
        closed$.subscribe(({ value }) => {
          if (!value) {
            this.api.colorService.remove(state, dispatch);
          }
          this.editorView.focus();
        });
      },
    },
  };

  private editorView: EditorView;

  constructor(protected menuController: ColorMenuController) {}

  public beforeInit(mode: EditorMode, schema: ColorSchema) {
    this.api = {
      colorService: new ColorService(schema.marks.color),
    };
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }
}
